import React from 'react';
import { Button } from './ui/Button';
import { ShieldCheck, ArrowRight } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function OfferSection() {
  return <section id="offer-section" className="bg-near-black text-off-white py-24 px-4" data-id="element-98">
      <div className="max-w-4xl mx-auto text-center space-y-10" data-id="element-99">
        <h2 className="text-4xl md:text-5xl font-serif text-white" data-id="element-100">
          Recupera tu ligereza hoy mismo.
        </h2>
        <p className="text-xl font-sans text-sage/90 max-w-2xl mx-auto" data-id="element-101">
          Deja de pelear contra tu cuerpo y dale las herramientas para que
          suelte lo que no necesita.
        </p>

        <div className="bg-white text-near-black p-8 md:p-12 max-w-2xl mx-auto shadow-2xl relative mt-12" data-id="element-102">
          {/* Decorative corner accents */}
          <div className="absolute top-0 left-0 w-4 h-4 border-t-2 border-l-2 border-dark-green m-4" data-id="element-103"></div>
          <div className="absolute top-0 right-0 w-4 h-4 border-t-2 border-r-2 border-dark-green m-4" data-id="element-104"></div>
          <div className="absolute bottom-0 left-0 w-4 h-4 border-b-2 border-l-2 border-dark-green m-4" data-id="element-105"></div>
          <div className="absolute bottom-0 right-0 w-4 h-4 border-b-2 border-r-2 border-dark-green m-4" data-id="element-106"></div>

          <div className="space-y-6" data-id="element-107">
            <h3 className="text-2xl font-serif text-dark-green" data-id="element-108">
              Protocolo Anti-Inflamatorio 72h
            </h3>
            <p className="font-sans text-gray-600" data-id="element-109">
              Acceso inmediato (PDF + Checklist)
            </p>

            <div className="py-6 border-y border-gray-100 my-6" data-id="element-110">
              <span className="text-sm font-sans text-gray-500 uppercase tracking-widest block mb-2" data-id="element-111">
                Precio Especial
              </span>
              <div className="flex items-center justify-center gap-4" data-id="element-112">
                <span className="text-3xl font-serif text-gray-400 line-through" data-id="element-113">
                  $27
                </span>
                <span className="text-6xl font-serif text-near-black" data-id="element-114">
                  $7.39
                </span>
              </div>
            </div>

            <Button href="https://thealphamethods.com/cart/44157988667478:1" onClick={trackAddToCart} className="w-full group py-5 text-xl" data-id="element-115">
              Descargar mi protocolo
              <ArrowRight className="ml-2 h-6 w-6 group-hover:translate-x-1 transition-transform" data-id="element-116" />
            </Button>

            <div className="flex items-center justify-center space-x-2 text-sm text-gray-500 font-sans mt-4" data-id="element-117">
              <ShieldCheck className="w-4 h-4 text-sage" data-id="element-118" />
              <span data-id="element-119">Tu compra es segura y el acceso es instantáneo.</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}